import { useEffect } from 'react';

export function useNavigationPrompt(when: boolean, message: string) {
    // Block React Router navigation (HashRouter uses pushState/replaceState internally)
    useEffect(() => {
        if (!when) return;

        const { pushState, replaceState } = window.history;

        window.history.pushState = function(...args: Parameters<typeof window.history.pushState>) {
            if (window.confirm(message)) {
                pushState.apply(window.history, args);
            }
        };

        window.history.replaceState = function(...args: Parameters<typeof window.history.replaceState>) {
            if (window.confirm(message)) {
                replaceState.apply(window.history, args);
            }
        };

        return () => {
            window.history.pushState = pushState;
            window.history.replaceState = replaceState;
        };
    }, [when, message]);

    // Block browser back/forward button
    useEffect(() => {
        if (!when) return;

        const handlePopState = () => {
            if (!window.confirm(message)) {
                window.history.pushState(null, '', window.location.href);
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [when, message]);

    // Block browser/tab close or hard refresh
    useEffect(() => {
        if (!when) return;

        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            e.returnValue = message;
            return message;
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [when, message]);
}
